export const SnortGeneral = { filterCutoff: 450 }; export default SnortGeneral;